import { IdLibelleCleModel } from "./referentiels/id.libelle.cle.model";

export class OutilSupport extends IdLibelleCleModel {
	libelle: keyof typeof TypeOutilSupport;
}

export enum TypeOutilSupport {
	USERSNAP
}
